/** Render as a real <a href>, never JS navigation or a 302: iOS skips universal links on both. */

import { getAppPid, type AppPlacementId } from "./appPlacements";

export const APP_LINK_BASE_URL = process.env.REACT_APP_BANNERS_LINK_BASE_URL;

export type AppDeepLinkValue = "orders" | "default";

export interface AppLinkParams {
  deepLinkValue: AppDeepLinkValue;
  arrival?: string | null;
  uid?: string | null;
  ref?: string | null;
  placement: AppPlacementId;
}

export const buildAppLink = ({
  deepLinkValue,
  arrival,
  uid,
  ref,
  placement,
}: AppLinkParams): string => {
  if (!APP_LINK_BASE_URL) {
    window.clientLogger?.error("App banners link is broken: REACT_APP_BANNERS_LINK_BASE_URL is not set", { deepLinkValue, placement });
  }

  const params = new URLSearchParams();

  params.set("pid", getAppPid(placement));
  params.set("deep_link_value", deepLinkValue);
  if (arrival) params.set("deep_link_sub1", arrival);
  if (uid) params.set("deep_link_sub2", uid);
  if (ref) params.set("deep_link_sub4", ref);

  return `${APP_LINK_BASE_URL}?${params.toString()}`;
};
